import {useState, useCallback } from 'react';
import Geocode from 'react-geocode';
import { useDeepCompareEffect } from 'use-deep-compare';

export const useMapCoords = ({
  location,
  venue,
  isMapOverridden,
  isVenueMapOverridden,
  isVenueAddressOverridden,
  MAP_KEY,
}) => {
  const [mapCoords, setMapCoords] = useState(null);

  const getCoords = useCallback(
    async (address, city, state, zipcode) => {
      try {
        Geocode.setApiKey(MAP_KEY);
        const response = await Geocode.fromAddress(
          `${address}, ${city}, ${state} ${zipcode}`,
        );
        const { lat, lng } = response.results[0].geometry.location;
        return { lat, lng };
      } catch {
        return { lat: null, lng: null };
      }
    },
    [MAP_KEY],
  );

   const updateCoords = async () => {
      const { address, city, state, mapLonLat, zipcode, addressLonLat } =
        location || {};
      const {
        address: venueAddress,
        city: venueCity,
        state: venueState,
        zipcode: venueZipcode,
        venueLonLat,
        venueAddressLonLat,
      } = venue || {};

      const mapLatitude = mapLonLat?.latitude;
      const mapLongitude = mapLonLat?.longitude;

      const venueMapLatitude = venueLonLat?.latitude;
      const venueMapLongitude = venueLonLat?.longitude;

      if (isVenueMapOverridden && venueMapLatitude && venueMapLongitude) {
        setMapCoords({
          latitude: Number.parseFloat(venueMapLatitude),
          longitude: Number.parseFloat(venueMapLongitude),
        });
      } else if (
        isVenueAddressOverridden &&
        venueAddress &&
        venueCity &&
        venueState &&
        venueZipcode
      ) {
        if (venueAddressLonLat?.latitude && venueAddressLonLat?.longitude) {
          setMapCoords(venueAddressLonLat);
        } else {
          const { lat, lng } = await getCoords(
            venueAddress,
            venueCity,
            venueState,
            venueZipcode,
          );
          if (lat && lng) {
            setMapCoords({ latitude: lat, longitude: lng });
          }
        }
      } else if (isMapOverridden && mapLatitude && mapLongitude) {
        setMapCoords({
          latitude: Number.parseFloat(mapLatitude),
          longitude: Number.parseFloat(mapLongitude),
        });
      } else if (address && city && state && zipcode) {
        if (addressLonLat?.latitude && addressLonLat?.longitude) {
          setMapCoords(addressLonLat);
        } else {
          const { lat, lng } = await getCoords(address, city, state, zipcode);
          if (lat && lng) {
            setMapCoords({ latitude: lat, longitude: lng });
          }
        }
      } else {
        setMapCoords(null);
      }
    };
  useDeepCompareEffect(() => {
    updateCoords();
  }, [
    location,
    venue,
    isMapOverridden,
    isVenueMapOverridden,
    isVenueAddressOverridden,
    getCoords,
  ]);

  return mapCoords;
};
